<div class="white-box p-3">
	<h1 class="mb-4">
		{{'nav.admin_actions' | translate}}
	</h1>
	<hr>
	<h4 class="mb-4">
		{{'admin.force_website_refresh' | translate}}
	</h4>
	<div class="row">
		<div class="col-md-12">
			<button type="button" class="btn btn-lg btn-primary" (click)="forceWebsiteRefresh()">{{'admin.force_website_refresh' | translate}}</button>
		</div>
	</div>
	<div *ngIf="userService.hasAccessFunction('super_admin', 'write')">
		<hr>
		<h4 class="mb-4">
			{{'admin.analytics_data_source' | translate}}
		</h4>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'g.source' | translate}}</label>
			<div class="col-sm-10">
				<ng-select
					[items]="analyticsSourceOptions"
					bindLabel="text"
					bindValue="key"
					name="analyticsSource"
					[clearable]="false"
					[(ngModel)]="analyticsSource"
				></ng-select>
				<small class="form-text text-muted">{{'admin.analytics_data_source_hint' | translate}}</small>
			</div>
		</div>

		<button class="btn btn-lg btn-primary" (click)="saveAnalyticsSource()" [disabled]="!analyticsSource || analyticsSource === savedAnalyticsSource">{{'g.save' | translate}}</button>

		<hr>
		<h4 class="mb-4">
			{{'admin.estimated_location' | translate}}
		</h4>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'admin.estimated_location_mode' | translate}}</label>
			<div class="col-sm-10">
				<ng-select
					[items]="estimatedLocationModeOptions"
					bindLabel="text"
					bindValue="key"
					name="estimatedLocationMode"
					[clearable]="false"
					[(ngModel)]="estimatedLocationMode"
				></ng-select>
				<small class="form-text text-muted">{{'admin.estimated_location_hint' | translate}}</small>
			</div>
		</div>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'admin.estimated_location_devices' | translate}}</label>
			<div class="col-sm-10">
				<textarea class="form-control" rows="3" name="estimatedLocationDevices" [(ngModel)]="estimatedLocationDevices" [disabled]="!estimatedLocationHasDevicesOption()" [ngClass]="{'invalid-input' : estimatedLocationDevicesHasError()}"></textarea>
				<small class="form-text text-muted">{{'admin.estimated_location_devices_hint' | translate}}</small>
				<small class="alert text-danger" *ngIf="estimatedLocationDevicesHasError()">{{'admin.estimated_location_invalid_devices' | translate}}</small>
			</div>
		</div>

		<button class="btn btn-lg btn-primary" (click)="saveEstimatedLocationFlag()" [disabled]="!estimatedLocationMode || !estimatedLocationHasChanges()">{{'g.save' | translate}}</button>

		<hr>
		<h4 class="mb-4">
			{{'admin.fw_update_throttle_limit' | translate}}
		</h4>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'admin.fw_update_throttle_limit_label' | translate}}</label>
			<div class="col-sm-10">
				<input type="number" min="1" step="1" class="form-control" name="fwUpdateThrottleLimit" [(ngModel)]="fwUpdateThrottleLimit" [ngClass]="{'invalid-input' : fwUpdateThrottleLimitHasError()}">
				<small class="form-text text-muted">{{'admin.fw_update_throttle_limit_hint' | translate}}</small>
				<small class="alert text-danger" *ngIf="fwUpdateThrottleLimitHasError()">{{'admin.fw_update_throttle_limit_invalid' | translate}}</small>
			</div>
		</div>

		<button class="btn btn-lg btn-primary" (click)="saveFwUpdateThrottleLimit()" [disabled]="!fwUpdateThrottleLimit || fwUpdateThrottleLimitHasError() || fwUpdateThrottleLimit === savedFwUpdateThrottleLimit">{{'g.save' | translate}}</button>

		<hr>
		<h4 class="mb-4">
			{{'admin.generate_script' | translate}}
		</h4>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'generate_script.pick_command' | translate}}</label>
			<div class="col-sm-10">
				<ng-select
					[items]="commands"
					bindLabel="text"
					bindValue="key"
					placeholder="{{'generate_script.pick_command' | translate}}"
					name="command"
					[(ngModel)]="command"
					(ngModelChange)="onCommandChange()"
				></ng-select>
			</div>
		</div>

		<div class="form-group row" *ngIf="commandHasMacOption()">
			<label class="col-sm-2 col-form-label">{{'generate_script.enterMac' | translate}}</label>
			<div class="col-sm-10">
				<input type="text" class="form-control mt-3" placeholder="{{'generate_script.enterMac' | translate}}" [(ngModel)]="macAddress" (blur)="validateMacAddress()" [ngClass]="{'invalid-input' : !validateMacAddress()}">
				<small class="alert text-danger" *ngIf="!validateMacAddress()">{{'generate_script.invalidMac' | translate}}</small>
			</div>
		</div>

		<div class="form-group row" *ngIf="commandHasSiteOption()">
			<label class="col-sm-2 col-form-label">{{'generate_script.enterSite' | translate}}</label>
			<div class="col-sm-10">
				<input type="text" class="form-control mt-3" placeholder="{{'generate_script.enterSite' | translate}}" [(ngModel)]="siteId" (blur)="validateSiteId()" [ngClass]="{'invalid-input' : !validateSiteId()}">
				<small class="alert text-danger" *ngIf="!validateSiteId()">{{'generate_script.invalidSite' | translate}}</small>
			</div>
		</div>

		<div class="form-group row" *ngIf="commandHasExcludeSitesOption()">
			<label class="col-sm-2 col-form-label">{{'generate_script.exclude_large_sites' | translate}}</label>
			<div class="col-sm-10">
				<mat-slide-toggle [(ngModel)]="excludeLargeSites"></mat-slide-toggle>
			</div>
		</div>

		<div class="form-group row" *ngIf="commandHasDeviceTypeOption()">
			<label class="col-sm-2 col-form-label">{{'devices.sct_device_type' | translate}}</label>
			<div class="col-sm-10">
				<ng-select [items]="deviceTypeOptions" bindLabel="name" bindValue="id" [multiple]="true"
					placeholder="{{'g.all' | translate}}" name="deviceTypes" [(ngModel)]="deviceTypes"></ng-select>
			</div>
		</div>

		<div class="form-group row">
			<label class="col-sm-2 col-form-label">{{'g.file_name' | translate}}</label>
			<div class="col-sm-10">
				<input type="text" class="form-control mt-3" placeholder="{{'g.file_name' | translate}}" [(ngModel)]="fileName">
			</div>
		</div>

		<button class="btn btn-lg btn-primary" (click)="sendGenerateCommand()" [disabled]="!command">{{'g.submit' | translate}}</button>
	</div>
</div>
